export enum ConsoleColors{
    RED='31m',
    BLUE='34m',
    YELLOW='33m'
}